module.exports = __webpack_public_path__ + "img/BAU_Partners_4.7163b751.jpg";